import { levelColor } from "@/lib/orbit";
import { cn } from "@/lib/utils";

// Circular gauge used for the headline scores.
export function ScoreRing({ score = 0, level, size = 132, stroke = 10, suffix = "/100", label }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, score));
  const offset = c - (pct / 100) * c;
  const color = level ? levelColor(level) : "hsl(var(--accent))";
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="hsl(var(--muted))" strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 900ms cubic-bezier(0.22,1,0.36,1)" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-num text-3xl font-semibold leading-none">{score}</span>
        <span className="font-num text-[11px] text-muted-foreground">{suffix}</span>
        {label && <span className="mt-1 text-[10px] uppercase tracking-widest text-muted-foreground">{label}</span>}
      </div>
    </div>
  );
}

export function DimensionBar({ label, score, className }) {
  const color = score >= 60 ? "hsl(160 84% 30%)" : score >= 50 ? "hsl(224 71% 45%)" : score >= 40 ? "hsl(32 95% 44%)" : "hsl(0 72% 48%)";
  return (
    <div className={cn("space-y-1.5", className)} data-testid={`dimension-${label}`}>
      <div className="flex items-baseline justify-between">
        <span className="text-sm font-medium text-foreground">{label}</span>
        <span className="font-num text-sm text-muted-foreground">{score}</span>
      </div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-muted">
        <div
          className="h-full rounded-full"
          style={{ width: `${score}%`, backgroundColor: color, transition: "width 800ms cubic-bezier(0.22,1,0.36,1)" }}
        />
      </div>
    </div>
  );
}
